<div class="w-100">
    <input-label [label]="translations.supplierNumber" [required]="required"></input-label>
    <div class="p-inputgroup w-100">
        <span class="p-inputgroup-addon"><i class="fa fa-code-merge"></i></span>
        <input type="text" pInputText [formControl]="control" [maxLength]="20" [readOnly]="disabled">
    </div>
</div>
